module.exports = __webpack_public_path__ + "media/question10_en.33764318.mp3";